/**
 * 打卡服务。使用签到接口，type=1
 * @returns
 */
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
import { watchSignApi } from '@/request/index.js';

class PunchServer extends BaseServer {
  constructor() {
    if (typeof PunchServer.instance === 'object') {
      return PunchServer.instance;
    }
    super();
    this.state = {
      waiting: false, // 倒计时等待中,跟页面中的icon同步
      iconVisible: false
    };
    PunchServer.instance = this;
    this.listenMsg()
    return this;
  }

  setState(key, value) {
    this.state[key] = value;
  }

  listenMsg() {
    // 房间消息
    useMsgServer().$onMsg('ROOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      // console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 开始推送打卡任务
        case 'punch_push':
          this.state.iconVisible = true
          this.$emit('punch_push', temp);
          break;
        // 打卡任务结束
        case 'punch_end':
          this.state.iconVisible = false
          this.$emit('punch_end', temp);
          break;
        // 直播结束
        case 'live_over':
          this.state.iconVisible = false
          this.$emit('live_over', temp);
          break;
        default:
          break;
      }
    });
    // 自定义消息
    useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 计时器暂停
        case 'timer_pause':
          this.$emit('timer_pause', temp);
          break;
        default:
          break;
      }
    });
  }

  punch(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.sign(params);
  }

  getPunchInfo(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.signInfo(params).then(res => {
      return res;
    });
  }

  punchStart(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.signStart(params).then(res => {
      return res;
    });
  }

  punchClose(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.signClose(params).then(res => {
      return res;
    });
  }

  getPunchRecordList(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.getSignRecordList(params);
  }

  getPunchCustomTips(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.getSignCustomTips(params);
  }
  getPunchCustomTips(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.getSignCustomTips(params);
  }
  createPunchCustomTips(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.createSignCustomTips(params);
  }
  editPunchCustomTips(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.editSignCustomTips(params);
  }
  delPunchCustomTips(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.delSignCustomTips(params);
  }
  delPunch(params) {
    if (params && typeof params === 'object') {
      params.type = 1;
    }
    return watchSignApi.delSign(params);
  }
}

export default function usePunchServer() {
  return new PunchServer();
}
